export function createBlob(content) {
    return new Blob([content], { type: 'text/csv;charset=utf-8;' });
}